import { useLiveQuery } from 'dexie-react-hooks'
import { offlineDb, type OfflineEntity } from './db'

export function usePendingEntityIds(entity: OfflineEntity): Set<number> {
  const ids = useLiveQuery(
    () => offlineDb.mutationQueue
      .where('entity').equals(entity)
      .toArray()
      .then(items => items
        .map(i => i.entityId)
        .filter((id): id is number => id != null)
      ),
    [entity]
  ) ?? []
  return new Set(ids)
}

export function usePendingTempIds(entity: OfflineEntity): Set<string> {
  const ids = useLiveQuery(
    () => offlineDb.mutationQueue
      .where('entity').equals(entity)
      .toArray()
      .then(items => items
        .filter(i => i.operation === 'create' && i.tempId != null)
        .map(i => i.tempId!)
      ),
    [entity]
  ) ?? []
  return new Set(ids)
}
